import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

const Badge = styled.span<{ $paired: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  color: ${({ $paired }) => ($paired ? "#115e59" : "#c11574")};
  background: ${({ $paired }) => ($paired ? "#dffbf4" : "#fdf2fa")};
  border: 1px solid ${({ $paired }) => ($paired ? "#14b8a6" : "#fcceee")};
`

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const SensorWorkStatus = ({ cell: { getValue } }: Props) => {
  const value = String(getValue().value || "")
  if (!value) return null

  const isConnected = value === "Connected"
  return <Badge $paired={isConnected}>{value}</Badge>
}
